export default __webpack_public_path__ + "static/media/1_0134.b9f35cb9.webp";